<template>
  <div class="row" style="margin-bottom: 1%">
    <div class="col">
      <label>Paciente</label>
      <div class="input-group input-focus">
        <a-auto-complete style="width: 200px" @search="handleSearchPaciente" class="form-control in">
          <template v-slot:dataSource>
            <a-select-option v-for="item in pacientesSearch" :key="item.id" :value="item.nome" @click="onSelectPac(item.id)">
              {{ item.nome }}
            </a-select-option>
          </template>
        </a-auto-complete>
      </div>
    </div>
    <div class="col">
      <label>Modo de Consulta</label>
      <select class="form-select" ref="modoConsulta" v-model="formConsult.tipoAgendamento">
        <option v-for="item in tipoAgenda" :key="item" :value="item.tipo">
          {{ item.descricao }}
        </option>
      </select>
    </div>
    <div class="col">
      <label>Categoria do Atendimento</label>
      <select class="form-select" ref="catAtendimento" v-model="formConsult.categoriaAtendimento">
        <option v-for="item in categorias" :key="item" :value="item.descricao">
          {{ item.descricao }}
        </option>
      </select>
    </div>
  </div>
  <div class="row" style="margin-bottom: 1%">
    <div class="col">
      <label>Início</label>
      <a-form-item>
        <a-date-picker class="form-control form-input-component" show-time type="date" placeholder="Data inicio" format="DD/MM/yyyy" style="width: 100%" v-model:value="dataInicio" />
      </a-form-item>
    </div>
    <div class="col">
      <label>Fim</label>
      <a-form-item>
        <a-date-picker class="form-control form-input-component" show-time type="date" format="DD/MM/yyyy" placeholder="Data fim" style="width: 100%" v-model:value="dataFim" />
      </a-form-item>
    </div>
    <div class="col">
      <label>Unidade</label>
      <select class="form-select" ref="catUnidade" v-model="formConsult.unidadeAtendimento">
        <option v-for="item in unidadeAtendimento" :key="item.descricao" :value="item.descricao">
          {{ item.descricao }}
        </option>
      </select>
    </div>
    <div class="col-sm-1" style="text-align: center">
      <div class="input-group-prepend" style="margin-top: 23px">
        <span class="input-group-text bg-white" @click="searchAgendados"><i class="fa fa-search"></i></span>
      </div>
    </div>
  </div>
  <a-table :dataSource="todosAtendimentos" :columns="columns">
    <template #paciente="{ record }">
      <a-tooltip title="Editar paciente" placement="right">
        <span class="paciente" @click="editarPaciente(record.paciente)">{{ record.paciente.nome }}</span>
      </a-tooltip>
    </template>
    <template #tipoAgendamento="{ record }">
      <div class="col col-icon">
        <div v-if="record.tipoAgendamento === 'VIRTUAL'">
          <a-tooltip title="Alterar para Presencial" placement="right">
            <i class="fa-solid fa-desktop icon-atendimento" @click="alterarAgendamento(record.id, 'PRESENCIAL', null)"></i>
          </a-tooltip>
          <a-tooltip title="Gerar link" placement="right">
            <div class="row">
              <span class="gerar-link">Gerar link da reunião <i class="fa-solid fa-link"></i></span>
            </div>
          </a-tooltip>
        </div>
        <a-tooltip title="Alterar para Virtual" placement="right" v-if="record.tipoAgendamento === 'PRESENCIAL'">
          <i class="fa-solid fa-people-carry-box icon-atendimento" @click="alterarAgendamento(record.id, 'VIRTUAL', null)"></i>
        </a-tooltip>
      </div>
    </template>
    <template #situacao="{ record }">
      <select class="form-select" ref="situacao" v-model="record.situacao" @change="alterarAgendamento(record.id, null, record.situacao)">
        <option v-for="item in situacaoAtendimento" :key="item" :value="item">
          {{ item }}
        </option>
      </select>
    </template>
    <template #registrarAtendimento="{ record }">
      <i class="fa-solid fa-circle-plus icon-atendimento" v-if="record"></i>
    </template>
  </a-table>
</template>

<script>
import { getProfissional, getProfissionalByCpf } from '@/components/service/profissionalService';
import { EnumTipoAgenda } from '@/components/models/enumTipoAgenda';
import { getPaciente } from '@/components/service/pacienteService';
import { getCategoriaAtendimento, getUnidadeAtendimento } from '@/config/servicos-utils';
import { openNotification, typesNotification } from '@/utils/notifications';
import { consultarAgendamento, updateAgendamento } from '@/components/service/agendamento-medico';
import { EnumTipoSituacao } from '@/components/models/enumSituacaoAtendimento';
import { getDataUser } from '@/utils';

export default {
  name: 'GerirAtendimentoProfissional',
  data() {
    return {
      selectedDate: null,
      profissionaisSearch: [],
      pacientesSearch: [],
      tipoAgenda: EnumTipoAgenda(),
      categorias: [],
      unidadeAtendimento: [],
      todosAtendimentos: [],
      dataInicio: null,
      dataFim: null,
      situacaoAtendimento: EnumTipoSituacao(),
      formConsult: {
        idProfissional: null,
        tipoAgendamento: null,
        categoriaAtendimento: null,
        unidadeAtendimento: null,
        dataInicio: null,
        dataFim: null,
        idPaciente: null,
      },
      columns: [
        {
          title: 'Data',
          dataIndex: 'data',
          key: 'data',
          slots: { customRender: 'data' },
        },
        {
          title: 'Horário',
          dataIndex: 'horario',
          key: 'horario',
          slots: { customRender: 'horario' },
        },
        {
          title: 'Paciente',
          dataIndex: 'paciente',
          key: 'paciente',
          slots: { customRender: 'paciente' },
        },
        {
          title: 'Modo da Consulta',
          dataIndex: 'tipoAgendamento',
          key: 'tipoAgendamento',
          slots: { customRender: 'tipoAgendamento' },
        },
        {
          title: 'Profissional',
          dataIndex: 'nomeProfissional',
          key: 'nomeProfissional',
          slots: { customRender: 'nomeProfissional' },
        },
        {
          title: 'Categoria do Atendimento',
          dataIndex: 'categoriaAtendimento',
          key: 'categoriaAtendimento',
          slots: { customRender: 'categoriaAtendimento' },
        },
        {
          title: 'Unidade',
          dataIndex: 'unidadeAtendimento',
          key: 'unidadeAtendimento',
          slots: { customRender: 'unidadeAtendimento' },
        },
        {
          title: 'Situação',
          dataIndex: 'situacao',
          key: 'situacao',
          slots: { customRender: 'situacao' },
        },
      ],
    };
  },
  async created() {
    await getProfissionalByCpf(getDataUser().cpf).then((r) => {
      this.formConsult.idProfissional = r.data.id;
    });
    await this.getCategoria();
    await this.getUnidade();
  },
  methods: {
    async handleSearch(value) {
      value.length >= 3
        ? await getProfissional({ nome: value }).then((r) => {
            this.profissionaisSearch = r.data.profissionais;
          })
        : (this.profissionaisSearch = []);
    },
    async handleSearchPaciente(value) {
      value.length >= 3
        ? await getPaciente({ nome: value }).then((r) => {
            console.log(r.data);
            this.pacientesSearch = r.data.pacientes;
          })
        : (this.pacientesSearch = []);
    },
    async getCategoria() {
      await getCategoriaAtendimento().then((r) => {
        this.categorias = r.data;
      });
    },
    async getUnidade() {
      await getUnidadeAtendimento().then((r) => {
        this.unidadeAtendimento = r.data;
      });
    },
    async searchAgendados() {
      let validate = this.verificarCampoPesquisa();
      if (validate) {
        await consultarAgendamento(this.formConsult).then((r) => {
          this.todosAtendimentos = r.data;
          console.log(r.data);
        });
      } else {
        openNotification(typesNotification.warning, 'Necessário algum campo preenchido para realizar a consulta.');
      }
    },
    onSelectPac(idPac) {
      this.formConsult.idPaciente = idPac;
    },
    verificarCampoPesquisa() {
      let validate = true;
      this.formConsult.dataInicio = this.dataInicio;
      this.formConsult.dataFim = this.dataFim;
      if (!this.formConsult.tipoAgendamento && !this.formConsult.categoriaAtendimento && !this.dataInicio && !this.formConsult.unidadeAtendimento && !this.formConsult.idPaciente) {
        validate = false;
      }
      return validate;
    },
    editarPaciente(paciente) {
      if (paciente.tipoPaciente === 'MILITAR') {
        this.$router.push({ path: '/form-paciente-militar/edit', query: { id: paciente.id } });
      } else {
        this.$router.push({ path: '/form-paciente-dependente/edit', query: { id: paciente.id } });
      }
    },
    async alterarAgendamento(id, tipoAtendimento, situacao) {
      await updateAgendamento({ id: id, tipoAtendimento: tipoAtendimento, situacao: situacao }).then(async () => {
        await this.searchAgendados();
      });
    },
  },
};
</script>

<style scoped>
.icon-atendimento {
  margin-left: 30px;
  font-size: 25px;
  cursor: pointer;
}

.icon-atendimento:hover {
  color: #03315f;
  text-shadow: 0 0 3px #03315f;
}

.gerar-link {
  text-align: center;
  font-size: 9px;
  cursor: pointer;
}

.paciente {
  font-size: 10px;
  cursor: pointer;
}
</style>
